<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="mobile_container">
                        <ul class="list_wrap" v-infinite-scroll="onLoadList">
                            <li class="list_item" v-for="row in tableData">
                                <div class="list_item_content">
                                    <p>
                                        应付编号：<span class="link-label" @click="handleClickDetail(row)">{{
                                            row.payable_no
                                        }}</span>
                                    </p>
                                    <template v-if="tabActiveName == 'purchase' || entity_type == 'supplier'">
                                        <p>供应商名称：{{ row.supplier_name }}</p>
                                        <p>
                                            采购编号：<span class="link-label">{{ row.purchase_no }}</span>
                                        </p>
                                    </template>
                                    <template v-else-if="tabActiveName == 'order_return' || entity_type == 'customer'">
                                        <p>
                                            客户公司名称：<span
                                                class="link-label"
                                                @click="
                                                    handleClickCustomerDetail(
                                                        row.customer_info && row.customer_info.id,
                                                        row.customer_info && row.customer_info.name
                                                    )
                                                "
                                                >{{ row.customer_info && row.customer_info.name }}</span
                                            >
                                        </p>
                                        <p>
                                            订单编号：<span class="link-label" @click="handleClickOrderDetail(row)">{{
                                                row.order_no
                                            }}</span>
                                        </p>
                                    </template>
                                    <template
                                        v-if="
                                            (tabActiveName !== 'payableSummary' &&
                                                tabActiveName !== 'purchase' &&
                                                tabActiveName !== 'order_return') ||
                                            entity_type == 'payee'
                                        "
                                    >
                                        <p>收款方：{{ row.payee_name }}</p>
                                    </template>
                                    <p>
                                        审批编号：<span
                                            class="link-label"
                                            @click="handleClickApprovalDetail(row.approval_id)"
                                            >{{ row.approval_id }}</span
                                        >
                                    </p>
                                    <div class="mobile_detail_head_user_wrap">
                                        申请人：
                                        <div
                                            class="mobile_detail_head_user"
                                            v-if="row.uid_info && row.uid_info.id"
                                            @click="handleClickUserInfo(row.uid_info)"
                                        >
                                            <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                            <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                        </div>
                                    </div>
                                    <p>开户行：{{ row.bank_name }}</p>
                                    <p>开户名：{{ row.account_name }}</p>
                                    <p>开户账号：{{ row.account_number }}</p>
                                </div>
                                <div class="list_item_amount">
                                    <div>
                                        <div class="list_item_amount_percent percent_bg1">
                                            应付金额：¥{{ row.payable_amount }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="list_item_amount_percent percent_bg2">
                                            已付金额：¥{{ row.paid_amount }}
                                        </div>
                                        <div class="list_item_amount_percent percent_bg4" v-if="row.unpaid_amount">
                                            未付金额：¥{{ row.unpaid_amount }}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </PullContainer>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
    </div>
</template>
<script>
import {
    PayablePurchaseDetailList,
    PayableOrderRefundDetailList,
    PayableApprovalDetailList,
    PayableSummaryDetail,
} from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "RayableStatisticsDetails",
    components: {
        PullContainer,
        ReturnNavBar,
        userDetailDialog,
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            tabActiveName: this.$route.query && this.$route.query.tabActiveName,
            customer_id: this.$route.query && this.$route.query.customer_id,
            supplier_name: this.$route.query && this.$route.query.supplier_name,
            payee_name: this.$route.query && this.$route.query.payee_name,
            entity_type: this.$route.query && this.$route.query.entity_type,
            entity_name: this.$route.query && this.$route.query.entity_name,
            entity_id: this.$route.query && this.$route.query.entity_id,
            source_id: this.$route.query && this.$route.query.source_id,
            // 详情
            loading: false,
            tableData: [],
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
        };
    },
    mixins: [pagination],
    created() {
        this.onSearch();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getMoreTypeData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getMoreTypeData();
            }
        },
        getMoreTypeData() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
            };
            if (this.tabActiveName == "purchase") {
                params.supplier_name = this.supplier_name;
                PayablePurchaseDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else if (this.tabActiveName == "order_return") {
                params.customer_id = this.customer_id;
                PayableOrderRefundDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else if (this.tabActiveName == "payableSummary") {
                params.entity_type = this.entity_type;
                if (this.entity_id) {
                    params.entity_id = this.entity_id;
                } else {
                    params.entity_name = this.entity_name;
                }
                PayableSummaryDetail(params).then((res) => {
                    if (res.code === 200) {
                        // const { data, total } = res.data;
                        // this.detailTableData = data || [];
                        this.tableData = res.data || [];
                        this.pagination.total = this.tableData.length;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else {
                params.source_id = this.source_id;
                params.payee_name = this.payee_name;
                PayableApprovalDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            }
        },
        // 详情
        handleClickDetail(row) {
            this.$router.push({
                name: "PayableDetails",
                query: {
                    payable_no: row.payable_no,
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    order_id: row.order_no,
                    name: row.order_no,
                    query_type: "order_no",
                },
            });
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            // this.$showApprovalDetail({
            //     approval_id,
            // }).then((res) => { });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/finance_management.scss";

.mobile_container {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
}
</style>
